<ng-template #inputTemplate let-charName="charName" let-index="index">
  @if (number().length >= index) {
    @let reverseIndex = number().length - index;

    @if (answer()[reverseIndex]; as char) {
      @let charCorrect = number()[reverseIndex] === answer()[reverseIndex];

      <div class="h-56 w-40">
        <div
          [ngClass]="{
            'border-emerald-600! bg-emerald-200': state() !== 'QUESTION' && charCorrect,
            'border-red-600! bg-red-200': state() !== 'QUESTION' && !charCorrect,
          }"
          animate.enter="anim-pop-in"
          animate.leave="anim-fade-out"
          class="bg-card-background border-surface-300 text-text-primary font-lexy2000s grid size-full place-items-center rounded-lg border-4 text-8xl transition-all duration-300 select-none"
          data-test-id="number-answer-character"
        >
          {{ char }}
        </div>
      </div>
    } @else {
      <div class="h-56 w-40">
        <div
          [ngClass]="{ 'border-primary-300! bg-primary-200/50! border-solid! ring-6': reverseIndex === answer().length }"
          animate.enter="anim-pop-in"
          class="ring-primary-400/50 grid size-full place-items-center rounded-lg border-4 border-dotted border-white bg-white/30 transition-all duration-300 select-none"
          data-test-id="number-input"
        >
          <p class="font-family-din text-7xl font-medium text-white/50">
            {{ charName }}
          </p>
        </div>
      </div>
    }
  }
</ng-template>

<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar [progress]="numberIndex()" [steps]="numbers().length" class="block w-full" name="Getallen Schrijven" />

  <rid-mechanic-content>
    <rid-mechanic-title [title]="'Schrijf het getal dat je hoort'" />

    <div class="flex flex-col items-center gap-8">
      @for (input of [number()]; track input) {
        <rid-audio-button
          #audioButton
          [src]="'/audio/numbers/' + number() + '.ogg'"
          size="LARGE"
          animate.enter="wait-500 anim-pop-in"
          ridSfx="BUBBLE_POP"
          (animationend)="$event.animationName === 'pop-in' ? audioButton.play() : undefined"
        />
      }

      <div class="flex gap-4">
        <ng-container [ngTemplateOutletContext]="{ index: 4, charName: 'D' }" [ngTemplateOutlet]="inputTemplate" />
        <ng-container [ngTemplateOutletContext]="{ index: 3, charName: 'H' }" [ngTemplateOutlet]="inputTemplate" />
        <ng-container [ngTemplateOutletContext]="{ index: 2, charName: 'T' }" [ngTemplateOutlet]="inputTemplate" />
        <ng-container [ngTemplateOutletContext]="{ index: 1, charName: 'E' }" [ngTemplateOutlet]="inputTemplate" />
      </div>

      <div class="mt-4 flex gap-2">
        @for (_ of [].constructor(10); track $index) {
          @let disabled = answer().length === number().length;
          <button
            (click)="addNumber($index)"
            [disabled]="disabled"
            [ngClass]="{ 'cursor-not-allowed opacity-75': disabled }"
            class="bg-card-background border-surface-300 text-text-primary font-lexy2000s grid h-32 w-24 cursor-pointer place-items-center rounded-lg border-4 text-6xl transition-all"
          >
            {{ $index }}
          </button>
        }

        <button
          (click)="backspace()"
          [disabled]="answer().length === 0"
          [ngClass]="{ 'cursor-not-allowed opacity-75': answer().length === 0 }"
          class="font-lexy2000s grid h-32 w-24 cursor-pointer place-items-center rounded-lg border-4 border-red-700 bg-red-500 text-white transition-all"
        >
          <i-backspace class="size-10" />
        </button>
      </div>
    </div>

    <rid-bottom-button (clicked)="checkAnswer()" [disabled]="answer().length !== number().length" content="Klaar" keybind="Enter" />

    @if (revelation(); as revelation) {
      <rid-modal-background [blur]="true" />
      <rid-correct-answer-modal (continue)="revealWaiter.finish()">
        <h3 class="font-family-din mb-4 text-lg">Het goede antwoord is:</h3>
        <p class="font-family-din text-6xl font-bold">{{ revelation }}</p>
      </rid-correct-answer-modal>
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
